import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from "../data.service";
import { ApiService } from '../api.service';
import { ConfirmationDialogService } from '../dialog-box/confirmation-dialog/confirmation-dialog.service'
import { CardReplaceDialogService } from '../dialog-box/card-replace-dialog/card-replace-dialog.service';
import { SetPinDialogService } from '../dialog-box/set-pin-dialog/set-pin-dialog.service';
import moment from 'moment';
import _lodash from 'lodash';
import { JSEncrypt } from 'jsencrypt';
import { AlertService } from 'src/app/_alert'
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-card-detail',
  templateUrl: './card-detail.component.html',
  styleUrls: ['./card-detail.component.scss']
})
export class CardDetailComponent implements OnInit {
  cardId: any;
  cardType: any;
  actionType: any
  isSaving = false;
  isReplacing = false;
  gettingTxn = false;
  panelExpanded = false;
  cardImageLoaded = false;
  userData: any;
  giftCards: any = {};
  midSecHt: any;
  page = 0;
  pageSize = 10;
  initialTxnList: any = [];
  transactions: any = [];
  blockUnblockText = "Block Card";
  selectedTxn: any = {};
  moment: any = moment;
  noMoreTxnText: any;
  giftCardsImageUrl: any;
  localUserObj: any = JSON.parse(localStorage.getItem("userObj"));
  cardCount: any;
  bottomSecDisplay = true;
  fetchingCvv = false;
  cvvFetched = false;

  isLoading: boolean = false;
  isInactive: boolean = false;
  displayExpiryMessage: boolean = false;

  expiryMessage: string;

  constructor(
    private dataService: DataService,
    private apiService: ApiService,
    private confirmationDialogService: ConfirmationDialogService,
    private cardReplaceDialogService: CardReplaceDialogService,
    private setPinDialogService: SetPinDialogService,
    private router: Router,
    protected activatedRoute: ActivatedRoute,
    public alertService: AlertService,
    protected renderer: Renderer2,
    protected elementRef: ElementRef
  ) {
    this.calculateHieght();
  }

  calculateHieght() {
    setTimeout(() => {
      let wh = window.innerHeight;
      let topSecHt = document.getElementById('topSec').offsetHeight;
      let bottomSecHt: any = 0;
      if (this.bottomSecDisplay) bottomSecHt = document.getElementById('bottomSec').offsetHeight || 0;
      this.midSecHt = (wh - topSecHt - bottomSecHt);
    });
  };

  ngOnInit(): void {
    this.cardCount = this.localUserObj.cardCount;
    this.activatedRoute.params.subscribe(params => {
      this.cardId = +params['id'];
    });
    this.dataService.getCardType().subscribe(val => {
      if (val) {
        this.cardType = val;
      }
    });
    this.giftCardsImageUrl = this.dataService.giftCardsImageUrl;
    this.getCardTransactions();
    this.getCardNumber();
  }

  getCardNumber() {
    const apiData = {
      "apiType": "get",
      "apiExt": `giftCards/get-card-details?giftCardUserId=${this.cardId}`,
    };
    this.apiService.customGetApiCall({}, apiData).then((res: any) => {
      if (res && res.data) {
        this.processAfterGetCards(res.data);
      }
    },
      (error) => { });
  }
  getGiftCardsImageUrl() {
    return this.giftCardsImageUrl;
  }
  processAfterGetCards(res: any) {
    if (!this.giftCardsImageUrl || this.giftCardsImageUrl != res.imageUrl) {
      this.giftCardsImageUrl = res.imageUrl;
      // this.dataService.giftCardsImageUrl = res.imageUrl;
    }
    if (this.cardType == 'Virtual Card' && res.giftCardStatus == 'BLOCKED') this.bottomSecDisplay = false;
    if (res.cardNo) res.cardNumber = res.cardNo;
    if (res.cardExpiry) {
      res.expDate = res.cardExpiry;
      const pattern = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/g;
      if (res.expDate && res.preExpirySmsNotificationDays && pattern.test(res.expDate)) {
        const expMonth = parseInt(res.expDate.split("/")[0]);
        const expYear = parseInt(res.expDate.split("/")[1]);
        const expFullYear = parseInt(new Date().getFullYear().toString().substring(0, 2) + expYear);
        const lastDay = new Date(expYear, expMonth, 0).getDate();
        if ((Math.abs(moment().diff(moment(expFullYear + '/' + expMonth + '/' + lastDay), 'days')) < (res.preExpirySmsNotificationDays))) {
          this.expiryMessage = 'Your gift card will get expired on ' + lastDay + '/' + res.expDate;
          this.displayExpiryMessage = true;
        }
      }
    }
    if (res.currentBalance) {
      res.currentBalance = res.currentBalance;
      res.currentBalance = Number(res.currentBalance);
    } else res.currentBalance = 0;
    if (res.cardNumber) res.cardNumber = res.cardNumber.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ')
    if (res.maskedCardNo) res.maskedCardNo = res.maskedCardNo.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ')
    if (res.isInactive === true) this.isInactive = true; else { this.isInactive = false; if (this.displayExpiryMessage) this.alertService.info(this.expiryMessage, { autoClose: true }); this.displayExpiryMessage = false; }
    this.giftCards = res;
  }

  previousState() {
    window.history.back();
  };

  getTxnTimeToDisplay(txnTime: any, txnDate: any) {
    let timeDispText = ''
    if (txnTime >= (7 * 24 * 60)) {
      let daycount = Math.floor((txnTime / (24 * 60)))
      timeDispText = moment(txnDate).format('DD/MM/YYYY')
    } else if (txnTime >= (24 * 60) && txnTime < (7 * 24 * 60)) {
      timeDispText = Math.floor((txnTime / (24 * 60))) + 'd ago';
    } else if (txnTime >= (60) && txnTime < (24 * 60)) {
      timeDispText = Math.floor((txnTime / (60))) + 'h ago';
    } else if (txnTime < 60) {
      timeDispText = txnTime + 'm ago'
    }
    return timeDispText;
  }

  getTxnTypeIcon(item: any) {
    if (item.transactionableType) return `./../../assets/img/${item.transactionableType}.png`
    else return './../../assets/img/SPEND.png';
  }
  gettxnIconColour(item) {
    if (item.transactionableType === 'RECOVERY') return '#ffe7c1';
    else if (item.transactionableType === 'REVERSAL') return '#c4ffc9';
    else if (item.transactionableType === 'REFUND') return '#c4ffc9';
    else if (item.transactionableType === 'AUTO_RECTIFICATION') return '#c4ffc9';
    else if (item.transactionableType === 'LOAD') return '#cbb6f5';
    else if (item.transactionableType === 'SPEND') return '#e0edf5';
    else if (item.transactionableType === 'HOLD_SETTLEMENT') return '#e0edf5';
  }

  getMoreTxnDetail(item: any) {
    item.displayDetail = !item.displayDetail
  }

  fetchCvv() {
    this.fetchingCvv = true;
    const apiData = {
      "apiType": "get",
      "apiExt": "giftCards/fetch-cvv?giftCardUserId=" + this.cardId,
    };

    this.apiService.customGetApiCall({}, apiData).then((res: any) => {
      if (res && res.data) {
        this.giftCards.cvv = res.data;
      };
      this.fetchingCvv = false;
      this.cvvFetched = true;
    },
      (error) => {
        this.fetchingCvv = false;
        this.cvvFetched = false;
      });
  }
  hideCvv() {
    this.giftCards.cvv = undefined;
    this.cvvFetched = false;
  }

  logOut() {
    this.apiService.logOut();
    this.panelExpanded = false;
  }

  editCard(processType: any) {
    this.isSaving = true;
    this.actionType = processType;
    let dialogData: any = {}
    dialogData.successBtnText = "Proceed";
    if (processType === 'lock') {
      dialogData.title = "Lock Card";
      dialogData.message = "You will not be able to do any transaction using this card once locked. Card once locked can be unlocked later. Are you sure you want to lock the card?";
    } else if (processType === 'block') {
      dialogData.title = "Block Card";
      dialogData.message = "You will not be able to do any transaction using this card once blocked. Card once blocked cannot be unblocked later. Are you sure you want to block the card?";
    }
    if (processType == 'unlock') this.processAfterEditCard(processType);
    else {
      this.isSaving = false;
      this.confirmationDialogService.confirm(dialogData.title, dialogData.message, dialogData.successBtnText)
        .then((confirmed) => {
          if (confirmed) this.processAfterEditCard(processType);
          else this.isSaving = false;
        })
        .catch((err) => {
          this.isSaving = false;
        });

    }

  }

  processAfterEditCard(processType: any) {
    this.isSaving = true;
    const reqObj: any = {};
    if (processType === 'lock') {
      reqObj.giftCardUserId = this.cardId;
      reqObj.editFlag = 'L'
    } else if (processType === 'block') {
      reqObj.giftCardUserId = this.cardId;
      reqObj.editFlag = 'B'
    } else if (processType === 'unlock') {
      reqObj.giftCardUserId = this.cardId;
      reqObj.editFlag = 'U'
    }
    const apiData = {
      "apiType": "post",
      "apiExt": "giftCards/edit-card",
    };
    this.apiService.customPostApiCall(reqObj, apiData).then((res: any) => {
      if (res) {
        this.getCardNumber();
      };
      this.isSaving = false;
    },
      (error) => {
        this.isSaving = false;
      });
  }

  replaceCard(processType) {
    let dialogData: any = {
      title: "Replace Card",
      message: "Replace Card",
      successBtnText: "Submit",
    }
    this.cardReplaceDialogService.confirm(dialogData.title, dialogData.message, dialogData.successBtnText)
      .then((respObj: any) => {
        if (!respObj) return;
        this.isReplacing = true;
        const reqObj: any = {
          giftCardUserId: this.cardId,
          newKitNumber: respObj.kitNo,
          newCardLastForDigit: respObj.cardLastDigits,
        };
        const apiData = {
          "apiType": "post",
          "apiExt": "giftCards/replace-card",
        };
        this.apiService.customPostApiCall(reqObj, apiData).then((res: any) => {
          if (res) {
            this.getCardNumber();
          };
          this.isReplacing = false;
        },
          (error) => {
            this.isReplacing = false;
          });
      })
      .catch((err) => {
        this.isReplacing = false;
      });

  }

  setPin() {
    let dialogData: any = {
      title: "Set PIN",
      message: "Set PIN",
      successBtnText: "Submit",
    }
    this.setPinDialogService.confirm(dialogData.title, dialogData.message, dialogData.successBtnText)
      .then((respData: any) => {
        // this.isSaving = true;
        if (!respData) return;
        var pin = respData.newPin;
        var kitNo = this.giftCards.currentKitNumber;
        var pinData = "0" + pin.length + pin.padEnd(14, 'F');
        var kitData = kitNo.padStart(16, '0');
        var bPin = this.hexToBytes(pinData);
        var bKit = this.hexToBytes(kitData);

        var pinBlockByte = new Array(bKit.length);

        for (var i = 0; i < bKit.length; i++) {
          pinBlockByte[i] = bPin[i] ^ bKit[i];
        }

        var pinBlock = this.bytesToHex(pinBlockByte).toUpperCase();

        const reqObj: any = {
          pinBlock: pinBlock,
          giftCardUserId: this.cardId
        };
        const apiData = {
          "apiType": "post",
          "apiExt": "giftCards/set-pin",
        };
        this.apiService.customPostApiCall(reqObj, apiData).then((res: any) => {
          if (res) { };
          this.isSaving = false;
        },
          (error) => {
            this.isSaving = false;
          });
      })
      .catch((err) => {
        this.isSaving = false;
      });

  }

  hexToBytes(hex) {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
      bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
  }

  // Convert a byte array to a hex string
  bytesToHex(bytes) {
    for (var hex = [], i = 0; i < bytes.length; i++) {
      var current = bytes[i] < 0 ? bytes[i] + 256 : bytes[i];
      hex.push((current >>> 4).toString(16));
      hex.push((current & 0xF).toString(16));
    }
    return hex.join("");
  }

  getMoreTransactions() {
    this.router.navigate(['/card-transaction', this.cardId]);
  }

  getCardTransactions() {
    _lodash.forEach(this.transactions, (obj: any) => {
      obj.displayDetail = false;
    });
    this.gettingTxn = true;
    this.noMoreTxnText = '';
    const apiData = {
      "apiType": "get",
      "apiExt": `giftCards/card-transactions?giftCardUserId=${this.cardId}&page=${this.page}&size=${this.pageSize}&sort=id,desc`,
    };
    this.apiService.customGetApiCall({}, apiData).then((res: any) => {
      if (res && res.data && res.data.content && res.data.content.length > 0) {
        this.processAfterTxnGet(res.data.content)
      } else {
        if (this.page > 0) {
          this.page = this.page - 1;
          this.noMoreTxnText = "No more Transactions available!"
        } else this.noMoreTxnText = "No Transactions available!"
        this.gettingTxn = false;
      }
    },
      (error) => {
        this.gettingTxn = false;
      });
  }

  processAfterTxnGet(res: any) {
    if (this.page == 0) {
      this.initialTxnList = _lodash.cloneDeep(res);
      this.transactions = this.initialTxnList.slice(0, 10);
    }
    else this.transactions = this.transactions.concat(res)
    this.gettingTxn = false;
  }

  onScroll() {
    return;
  }

  copyCardNumber() {
    // remove spaces between characters
    let cardNumber = _lodash.cloneDeep(this.giftCards.cardNumber);
    cardNumber = cardNumber.replace(/\s/g, '');

    // for copy cardNumber
    const selBox = this.renderer.createElement('textarea');

    this.renderer.setStyle(selBox, 'position', 'fixed');
    this.renderer.setStyle(selBox, 'left', '0');
    this.renderer.setStyle(selBox, 'top', '0');
    this.renderer.setStyle(selBox, 'opacity', '0');

    selBox.value = cardNumber;

    this.renderer.appendChild(this.elementRef.nativeElement, selBox);

    selBox.focus();
    selBox.select();

    // document.execCommand('copy');
    navigator.clipboard.writeText(selBox.value).then(() => {
      console.log('Text copied to clipboard successfully.');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });

    this.renderer.removeChild(this.elementRef.nativeElement, selBox);

    this.alertService.success('Card Number copied', { autoClose: true });
  }

  showHideCvvChange() {
    if (!this.giftCards.cvv) this.fetchCvv();
    else this.hideCvv();
  }

  toggleActivationModal() {
    this.isInactive = !this.isInactive;
    if (this.displayExpiryMessage) this.alertService.info(this.expiryMessage, { autoClose: true }); this.displayExpiryMessage = false;
  }

  activateCard() {
    this.isLoading = true;
    const reqObj = {
      giftCardUserId: this.cardId
    };
    const apiData = {
      "apiType": "post",
      "apiExt": 'giftCards/activate-card',
    };
    this.apiService.customPostApiCall(reqObj, apiData).then((res: any) => {
      this.toggleActivationModal();
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.toggleActivationModal();
        console.log(err);
      }
    );
  }

}
